export default {
  representante: [],
  representante_firebase: null,
  isLoading: false
}
